import Trigger from "@boxes/boxes/Trigger";
import AverageTicketFilter from "@boxes/boxes/filters/AverageTicketFilter";
import OrderCountFilter from "@boxes/boxes/filters/OrderCountFilter";
import TotalSpendFilter from "@boxes/boxes/filters/TotalSpendFilter";
import AudienceGroup from "@boxes/boxes/groups/AudienceGroup";
import ConditionalGroup from "@boxes/boxes/groups/ConditionalGroup";
import CreativeGroupAction from "@boxes/boxes/groups/CreativeGroupAction";
import FilterGroup from "@boxes/boxes/groups/FilterGroup";
import EmailCreativeAction from "@boxes/boxes/outputs/EmailCreativeAction";
import ExportAudienceOutput from "@boxes/boxes/outputs/ExportAudienceOutput";
import PushCreativeAction from "@boxes/boxes/outputs/PushCreativeAction";
import SmsCreativeAction from "@boxes/boxes/outputs/SmsCreativeAction";
import WhatsAppCreativeAction from "@boxes/boxes/outputs/WhatsAppCreativeAction";
import FullAudience from "@boxes/boxes/sources/FullAudience";
import ImportedAudience from "@boxes/boxes/sources/ImportedAudience";
import BroadcastAudience from "@boxes/boxes/sources/BroadcastAudience";
import SavedAudience from "@boxes/boxes/sources/SavedAudience";
import AgeConditional from "./boxes/conditionals/AgeConditional";
import AverageTicketConditional from "./boxes/conditionals/AverageTicketConditional";
import BirthdayConditional from "./boxes/conditionals/BirthdayConditional";
import BrandsAndUnitsConditional from "./boxes/conditionals/BrandsAndUnitsConditional";
import ClimateProfileConditional from "./boxes/conditionals/ClimateProfileConditional";
import ConsumedProductsConditional from "./boxes/conditionals/ConsumedProductsConditional";
import ConsumptionMomentsConditional from "./boxes/conditionals/ConsumptionMomentsConditional";
import DayOfMonthConditional from "./boxes/conditionals/DayOfMonthConditional";
import DayOfWeekConditional from "./boxes/conditionals/DayOfWeekConditional";
import DaysWithoutConversionConditional from "./boxes/conditionals/DaysWithoutConversionConditional";
import LastConversionConditional from "./boxes/conditionals/LastConversionConditional";
import OrderConditional from "./boxes/conditionals/OrderConditional";
import OrderCountConditional from "./boxes/conditionals/OrderCountConditional";
import OrderFrequencyConditional from "./boxes/conditionals/OrderFrequencyConditional";
import OriginConditional from "./boxes/conditionals/OriginConditional";
import RFVProfileConditional from "./boxes/conditionals/RFVProfileConditional";
import RegionConditional from "./boxes/conditionals/RegionConditional";
import RegisterTimeConditional from "./boxes/conditionals/RegisterTimeConditional";
import SpecificClimateConditional from "./boxes/conditionals/SpecificClimateConditional";
import SpecificDayConditional from "./boxes/conditionals/SpecificDayConditional";
import TotalSpendConditional from "./boxes/conditionals/TotalSpendConditional";
import AgeFilter from "./boxes/filters/AgeFilter";
import BirthdayFilter from "./boxes/filters/BirthdayFilter";
import BrandsAndUnitsFilter from "./boxes/filters/BrandsAndUnitsFilter";
import ClimateProfileFilter from "./boxes/filters/ClimateProfileFilter";
import ConsumedProductsFilter from "./boxes/filters/ConsumedProductsFilter";
import ConsumptionMomentsFilter from "./boxes/filters/ConsumptionMomentsFilter";
import CustomerPhoneFilter from "./boxes/filters/CustomerPhoneFilter";
import DaysWithoutConversionFilter from "./boxes/filters/DaysWithoutConversionFilter";
import LastConversionFilter from "./boxes/filters/LastConversionFilter";
import OrderFilter from "./boxes/filters/OrderFilter";
import OrderFrequencyFilter from "./boxes/filters/OrderFrequencyFilter";
import OriginFilter from "./boxes/filters/OriginFilter";
import RFVProfileFilter from "./boxes/filters/RFVProfileFilter";
import RegionFilter from "./boxes/filters/RegionFilter";
import RegisterTimeFilter from "./boxes/filters/RegisterTimeFilter";
import EventSource from "./boxes/sources/EventSource";

export const BoxComponents = {
  AudienceGroup,
  FilterGroup,
  EventSource,
  ConditionalGroup,
  CreativeGroupAction,
  Trigger,
  FullAudience,
  SavedAudience,
  ImportedAudience,
  BroadcastAudience,
  ExportAudienceOutput,
  SmsCreativeAction,
  PushCreativeAction,
  EmailCreativeAction,
  WhatsAppCreativeAction,
  AverageTicketFilter,
  OrderCountFilter,
  TotalSpendFilter,
  LastConversionFilter,
  BirthdayFilter,
  AgeFilter,
  ConsumedProductsFilter,
  ConsumptionMomentsFilter,
  RegionFilter,
  RegisterTimeFilter,
  ClimateProfileFilter,
  OriginFilter,
  BrandsAndUnitsFilter,
  DayOfWeekConditional,
  DayOfMonthConditional,
  SpecificDayConditional,
  SpecificClimateConditional,
  AverageTicketConditional,
  OrderCountConditional,
  RegionConditional,
  OrderConditional,
  OrderFilter,
  TotalSpendConditional,
  RegisterTimeConditional,
  AgeConditional,
  LastConversionConditional,
  BirthdayConditional,
  ClimateProfileConditional,
  ConsumedProductsConditional,
  ConsumptionMomentsConditional,
  OriginConditional,
  BrandsAndUnitsConditional,
  DaysWithoutConversionFilter,
  DaysWithoutConversionConditional,
  OrderFrequencyConditional,
  RFVProfileConditional,
  OrderFrequencyFilter,
  RFVProfileFilter,
  CustomerPhoneFilter,
};
